import { CONTACT, WHATSAPP } from '../../constants';
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <h3 className="footer__logo">EcoClean</h3>
          <p className="footer__text">Limpieza sustentable en Santa Rosa, La Pampa.</p>
        </div>
        <div className="footer__links">
          <a href={WHATSAPP.url} target="_blank" rel="noreferrer">WhatsApp</a>
          <a href={CONTACT.instagram} target="_blank" rel="noreferrer">Instagram</a>
          <a href={`https://www.google.com/maps/dir/?api=1&destination=${CONTACT.mapLat},${CONTACT.mapLng}`} target="_blank" rel="noreferrer">Cómo llegar</a>
        </div>
        <div className="footer__credits">
          <p className="footer__text">{CONTACT.fullAddress}</p>
          <p className="footer__text footer__small">
            &copy; {new Date().getFullYear()} EcoClean · Sitio web por{' '}
            <a href="https://www.linkedin.com/in/axel-liscovsky/" target="_blank" rel="noreferrer">Axel Liscovsky</a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
